var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import * as API from './api';
import * as UserSrv from './user-service';
let Problem = class Problem extends Vue {
    constructor() {
        super(...arguments);
        this.show_editor = false;
        this.identity = UserSrv.identity;
        this.problem = null;
        this.rates = null;
        this.lang = '';
        this.source_file = null;
        this.code = null;
    }
    fetchData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.problem_uid = parseInt(this.$route.params['problem_uid']);
            let result = yield API.getProblem(this.problem_uid);
            if (result !== 'Error') {
                this.problem = result;
                this.lang = this.problem.lang;
                if (this.identity !== null) {
                    this.rate_category = this.identity.category;
                }
                else {
                    this.rate_category = UserSrv.UserCategory.universe;
                }
                yield this.fetchRate();
            }
        });
    }
    fetchRate() {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield API.getProblemRate(this.problem_uid, this.rate_category);
            if (result === 'Error') {
                this.rates = [];
            }
            else {
                this.rates = result;
            }
        });
    }
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetchData();
            this.editor = ace.edit("editor");
            this.editor.setTheme("ace/theme/monokai");
            switch (this.lang) {
                case 'g++':
                case 'makefile':
                    this.editor.getSession().setMode("ace/mode/c_cpp");
                    break;
                case 'python3':
                    this.editor.getSession().setMode("ace/mode/python");
                    break;
            }
            this.editor.getSession().on('change', () => {
                this.code = this.editor.getValue();
            });
        });
    }
    onToggleEditor() {
        this.show_editor = !this.show_editor;
        if (this.show_editor && this.code !== null) {
            this.editor.setValue(this.code);
        }
    }
    onChangeFile() {
        let e_file = this.$refs['file'];
        if (e_file === undefined) {
            this.source_file = null;
        }
        else if (e_file.files === null || e_file.files.length === 0) {
            this.source_file = null;
        }
        else {
            this.source_file = e_file.files[0];
            let reader = new FileReader();
            reader.onload = () => __awaiter(this, void 0, void 0, function* () {
                this.code = reader.result;
                this.editor.setValue(this.code);
            });
            reader.readAsText(this.source_file);
        }
    }
    onContentLoaded() {
        if (this.problem !== null) {
            iFrameResize({});
            let e_content = this.$refs['content'];
            e_content.iFrameResizer.sendMessage({
                problem_uid: this.problem.uid,
                revision: this.problem.revision
            });
        }
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.code !== null) {
                let challenge_uid = yield API.submit(this.problem_uid, this.code, this.lang);
                if (challenge_uid !== 'Error') {
                    this.$router.push(`/challenge/${challenge_uid}/`);
                }
            }
        });
    }
};
__decorate([
    Watch('$route'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], Problem.prototype, "fetchData", null);
Problem = __decorate([
    Component
], Problem);
export default Problem;



// WEBPACK FOOTER //
// ./src/Problem.vue